import Dashboard from "./Dashboard";

export { Dashboard };
